<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="80%"
      class="chartDia"
      @close="close"
    >
      <div slot="title" class="slotTit">修改记录</div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="修改时间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="生效时间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="修改来源"
        >
          <template slot-scope="{ row }">
            {{ row.projectPayPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="修改记录">
          <template slot-scope="{ row }">
            <el-button type="text" @click="downloadFile(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button @click="close" type="primary" style="margin-top:20px;">
        确认
      </el-button>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { riskControl, alreadyPlatDownBack } from '@/api/ajax';
import { getStorage } from '@/tools/storage';
export default {
  mixins: [pageInation],
  props: {
    showDialog: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      getList: riskControl.digital.list, // 获取列表的AJAX
      showDetail: false,
      searchQuery: {
        projectId: this.$route.query.id,
        enterpriseId: ''
      }
    };
  },
  computed: {
    myrouter() {
      return this.$route.query.activeTask;
    }
  },
  methods: {
    close() {
      this.$parent.show = false;
    },
    downloadFile(row) {
      try {
        let a = JSON.parse(localStorage.getItem('activeTask')) || {};
        let { orderServiceId, taskDt } = row;
        let { projectName } = a;

        projectName = projectName || '';
        window.open(
          `${alreadyPlatDownBack}?orderServiceId=${orderServiceId}&projectName=${projectName}&taskDt=${taskDt}`
        );
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {
    const user = getStorage('user');
    this.searchQuery.enterpriseId = user.enterpriseId;
  }
};
</script>
